<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container">
    <mat-card class="loading-card">
        <mat-card-content class="loading-content">
            <mat-spinner diameter="50"></mat-spinner>
            <p class="loading-text">Cargando detalles de la liquidación...</p>
        </mat-card-content>
    </mat-card>
</div>

<!-- Error State -->
<div *ngIf="error && !isLoading" class="error-container">
    <mat-card class="error-card">
        <mat-card-content class="error-content">
            <mat-icon class="error-icon">error</mat-icon>
            <h3 class="error-title">Error al cargar datos</h3>
            <p class="error-message">{{ error }}</p>
            <button mat-raised-button color="primary" (click)="volverALista()">
                <mat-icon>arrow_back</mat-icon>
                Volver a la lista
            </button>
        </mat-card-content>
    </mat-card>
</div>

<!-- Main Content -->
<div *ngIf="!isLoading && !error && liquidacion" class="detalle-container">
    <mat-card
        class="trinta-card mb-25 bg-white border-none d-block liquidacion-detalle-card"
    >
        <mat-card-header
            class="liquidacion-header d-flex align-items-center justify-content-between"
        >
            <div class="header-left">
                <button
                    mat-stroked-button
                    color="primary"
                    class="back-button"
                    (click)="volverALista()"
                    aria-label="Volver al listado"
                >
                    <mat-icon class="mr-1">arrow_back</mat-icon>
                    Volver al Listado
                </button>
            </div>
            <div class="header-right flex-grow-1">
                <h4 class="mb-0 mt-2 text-primary fw-bold">
                    Liquidación Agencia #{{ liquidacion.id }}
                </h4>
                <p class="subtitle text-secondary mb-0">
                    {{
                        datosConsolidados?.cliente ||
                            liquidacion.cliente ||
                            'N/A'
                    }}
                    - {{ liquidacion.mesAnio }}
                </p>
            </div>
        </mat-card-header>
    </mat-card>

    <!-- Tabs Content -->
    <mat-card class="trinta-card mb-25 bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">Detalle de Liquidación</h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <mat-tab-group
                [(selectedIndex)]="selectedTabIndex"
                (selectedIndexChange)="onTabIndexChange($event)"
                animationDuration="300ms"
                mat-stretch-tabs="false"
                mat-align-tabs="start"
            >
                <!-- Tab 1: Totales -->
                <mat-tab label="Totales">
                    <div class="tab-content">
                        <div class="financial-summary">
                            <!-- Loading para resumen financiero -->
                            <div
                                *ngIf="isLoading || isLoadingTotales"
                                class="loading-section"
                            >
                                <mat-spinner diameter="40"></mat-spinner>
                                <p>Cargando resumen financiero...</p>
                            </div>

                            <!-- Contenido del resumen financiero -->
                            <div
                                *ngIf="
                                    !isLoading &&
                                    !isLoadingTotales &&
                                    liquidacion
                                "
                                class="financial-content"
                            >
                                <div
                                    class="resumen-operacion-card"
                                    *ngIf="false"
                                >
                                    <h3 class="section-title">
                                        Resumen Operación
                                    </h3>
                                    <div class="resumen-table">
                                        <div class="resumen-header">
                                            <div class="header-item">ITEM</div>
                                            <div
                                                class="header-item text-center"
                                            >
                                                CNTR
                                            </div>
                                            <div
                                                class="header-item text-center"
                                            >
                                                PLTS
                                            </div>
                                            <div class="header-item text-end">
                                                SUBTOTAL
                                            </div>
                                        </div>

                                        <!-- Items Principales -->
                                        <div class="resumen-row">
                                            <div class="row-item">
                                                AGENCIAMIENTO
                                            </div>
                                            <div
                                                class="row-item text-center text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.agenciamientoCntr
                                                    )
                                                }}
                                            </div>
                                            <div
                                                class="row-item text-center text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.agenciamientoPlts
                                                    )
                                                }}
                                            </div>
                                            <div class="row-item text-end">
                                                {{
                                                    formatearMoneda(
                                                        resumenFinanciero?.agenciamientoSubtotal
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <div class="resumen-row">
                                            <div class="row-item">
                                                TRANSPORTE
                                            </div>
                                            <div
                                                class="row-item text-center text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.transporteCntr
                                                    )
                                                }}
                                            </div>
                                            <div
                                                class="row-item text-center text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.transportePlts
                                                    )
                                                }}
                                            </div>
                                            <div class="row-item text-end">
                                                {{
                                                    formatearMoneda(
                                                        resumenFinanciero?.transporteSubtotal
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <div class="resumen-row">
                                            <div class="row-item">
                                                OS VENTA**
                                            </div>
                                            <div
                                                class="row-item text-center text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.osVentaCntr
                                                    )
                                                }}
                                            </div>
                                            <div
                                                class="row-item text-center text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.osVentaPlts
                                                    )
                                                }}
                                            </div>
                                            <div class="row-item text-end">
                                                {{
                                                    formatearMoneda(
                                                        resumenFinanciero?.osVentaSubtotal
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <!-- Totales -->
                                        <div class="resumen-row total-neto">
                                            <div class="row-item fw-bold">
                                                TOTAL NETO
                                            </div>
                                            <div
                                                class="row-item text-center text-end fw-bold"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.totalNetoCntr
                                                    )
                                                }}
                                            </div>
                                            <div
                                                class="row-item text-center text-end fw-bold"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.totalNetoPlts
                                                    )
                                                }}
                                            </div>
                                            <div
                                                class="row-item text-end fw-bold"
                                            >
                                                {{
                                                    formatearMoneda(
                                                        resumenFinanciero?.totalNetoSubtotal
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <div class="resumen-row">
                                            <div class="row-item">IVA</div>
                                            <div class="row-item"></div>
                                            <div class="row-item"></div>
                                            <div class="row-item text-end">
                                                {{
                                                    formatearMoneda(
                                                        resumenFinanciero?.iva
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <div class="resumen-row total-bruto">
                                            <div class="row-item fw-bold">
                                                TOTAL BRUTO
                                            </div>
                                            <div class="row-item"></div>
                                            <div class="row-item"></div>
                                            <div
                                                class="row-item text-end fw-bold"
                                            >
                                                {{
                                                    formatearMoneda(
                                                        resumenFinanciero?.totalBruto
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <div
                                            class="resumen-header resumen-section mt-2"
                                        >
                                            <div class="header-item">ITEM</div>
                                            <div
                                                class="header-item text-center"
                                            >
                                                CNTR
                                            </div>
                                            <div
                                                class="header-item text-center"
                                            >
                                                PLTS
                                            </div>
                                            <div class="header-item text-end">
                                                SUBTOTAL
                                            </div>
                                        </div>

                                        <div class="resumen-row">
                                            <div class="row-item">
                                                OS TRASPASO***
                                            </div>
                                            <div
                                                class="row-item text-center text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.osTraspasoCntr
                                                    )
                                                }}
                                            </div>
                                            <div
                                                class="row-item text-center text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        resumenFinanciero?.osTraspasoPlts
                                                    )
                                                }}
                                            </div>
                                            <div class="row-item text-end">
                                                {{
                                                    formatearMoneda(
                                                        resumenFinanciero?.osTraspasoSubtotal
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <div class="resumen-row total-pagar">
                                            <div class="row-item fw-bold">
                                                TOTAL A PAGAR
                                            </div>
                                            <div class="row-item"></div>
                                            <div class="row-item"></div>
                                            <div
                                                class="row-item text-end fw-bold"
                                            >
                                                {{
                                                    formatearMoneda(
                                                        resumenFinanciero?.totalPagar
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="resumen-footer mt-3">
                                        <p class="footnote text-secondary">
                                            ** OS Venta: factura emitida a OPB,
                                            valor neto a pagar.
                                        </p>
                                        <p class="footnote text-secondary">
                                            *** OS Traspaso: factura emitida al
                                            cliente, valor bruto a pagar.
                                        </p>
                                    </div>
                                </div>
                                <div class="resumen-operacion-card">
                                    <h3 class="section-title">Totales</h3>

                                    <div
                                        *ngIf="totalesPorNaveRows.length > 0"
                                        class="table-container"
                                    >
                                        <table
                                            mat-table
                                            [dataSource]="
                                                totalesPorNaveDataSource
                                            "
                                            class="data-table"
                                        >
                                            <ng-container matColumnDef="nave">
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                >
                                                    Nave
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                >
                                                    {{
                                                        isGlobalTotalesRow(row)
                                                            ? 'Total'
                                                            : row.nave
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="pol">
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                >
                                                    POL
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                >
                                                    {{
                                                        isGlobalTotalesRow(row)
                                                            ? ''
                                                            : row.pol
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="etd">
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                >
                                                    ETD
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="nowrap"
                                                >
                                                    {{
                                                        isGlobalTotalesRow(row)
                                                            ? ''
                                                            : formatearFechaCorta(
                                                                  row.etd
                                                              )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container
                                                matColumnDef="exportador"
                                            >
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                >
                                                    Exportador
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                >
                                                    {{
                                                        isGlobalTotalesRow(row)
                                                            ? ''
                                                            : row.exportador
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="cntrs">
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    CNTRs
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearNumero(
                                                            row.cntrs
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="sConv">
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    S/Conv
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearNumero(
                                                            row.sConv
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="plts">
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    PLTS
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearNumero(
                                                            row.plts
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="cajas">
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    Cajas
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearNumero(
                                                            row.cajas
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container
                                                matColumnDef="montoAge"
                                            >
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    Monto AGE
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearMoneda(
                                                            row.montoAge
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container
                                                matColumnDef="montoTransporte"
                                            >
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    Monto T.T.
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearMoneda(
                                                            row.montoTransporte
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container
                                                matColumnDef="montoOrdenesServicios"
                                            >
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    Monto O/S
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearMoneda(
                                                            row.montoOrdenesServicios
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container
                                                matColumnDef="gestionOpbNeto"
                                            >
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    Gestion OPB Neto
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearMoneda(
                                                            row.gestionOpbNeto
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container
                                                matColumnDef="totalVentaNeto"
                                            >
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    Total venta neto
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearMoneda(
                                                            row.totalVentaNeto
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <ng-container
                                                matColumnDef="totalTraspasoBruto"
                                            >
                                                <th
                                                    mat-header-cell
                                                    *matHeaderCellDef
                                                    class="text-end"
                                                >
                                                    Total traspaso bruto
                                                </th>
                                                <td
                                                    mat-cell
                                                    *matCellDef="let row"
                                                    class="text-end"
                                                >
                                                    {{
                                                        formatearMoneda(
                                                            row.totalTraspasoBruto
                                                        )
                                                    }}
                                                </td>
                                            </ng-container>

                                            <tr
                                                mat-header-row
                                                *matHeaderRowDef="
                                                    totalesPorNaveColumns
                                                "
                                            ></tr>
                                            <tr
                                                mat-row
                                                *matRowDef="
                                                    let row;
                                                    columns: totalesPorNaveColumns
                                                "
                                                [ngClass]="
                                                    isGlobalTotalesRow(row)
                                                        ? 'totales-row'
                                                        : ''
                                                "
                                            ></tr>
                                        </table>
                                    </div>

                                    <div
                                        *ngIf="totalesPorNaveRows.length === 0"
                                        class="no-data"
                                    >
                                        <mat-icon>info</mat-icon>
                                        <p>
                                            No hay totales por nave disponibles
                                            para esta liquidación
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Mensaje cuando no hay datos -->
                            <div
                                *ngIf="!isLoading && !liquidacion"
                                class="no-data"
                            >
                                <mat-icon>info</mat-icon>
                                <p>
                                    No hay información financiera disponible
                                    para esta liquidación
                                </p>
                            </div>
                        </div>
                    </div>
                </mat-tab>

                <!-- Tab 2: Contenedores -->
                <mat-tab label="Contenedores">
                    <div class="tab-content">
                        <div class="containers-section">
                            <h3 class="section-title">
                                Detalle de Contenedores ({{
                                    contenedoresDataSource.data.length
                                }})
                            </h3>

                            <!-- Loading para contenedores -->
                            <div
                                *ngIf="isLoadingContenedores"
                                class="loading-section"
                            >
                                <mat-spinner diameter="40"></mat-spinner>
                                <p>Cargando contenedores...</p>
                            </div>

                            <!-- Tabla de contenedores -->
                            <div
                                *ngIf="
                                    !isLoadingContenedores &&
                                    contenedores.length > 0
                                "
                                class="table-container"
                            >
                                <table
                                    mat-table
                                    [dataSource]="contenedoresDataSource"
                                    class="data-table"
                                >
                                    <ng-container
                                        *ngFor="let col of contenedoresColumns"
                                        [matColumnDef]="col"
                                    >
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            class="nowrap-col-header"
                                        >
                                            {{ col }}
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let row"
                                            [ngClass]="{
                                                'text-end':
                                                    !esColumnaTextoContenedor(col),
                                                nowrap: col === 'ETD',
                                            }"
                                        >
                                            {{
                                                formatoCeldaContenedorTab(
                                                    col,
                                                    row[col]
                                                )
                                            }}
                                        </td>
                                        <td
                                            mat-footer-cell
                                            *matFooterCellDef
                                            [ngClass]="{
                                                'text-end':
                                                    !esColumnaTextoContenedor(col),
                                            }"
                                        >
                                            {{
                                                col === contenedoresColumns[0]
                                                    ? 'Total'
                                                    : formatoCeldaContenedorTab(
                                                          col,
                                                          totalesContenedoresRow
                                                              ? totalesContenedoresRow[
                                                                    col
                                                                ]
                                                              : null
                                                      )
                                            }}
                                        </td>
                                    </ng-container>
                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="contenedoresColumns"
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: contenedoresColumns
                                        "
                                    ></tr>
                                    <tr
                                        mat-footer-row
                                        *matFooterRowDef="contenedoresColumns"
                                        class="totales-row"
                                        [hidden]="!totalesContenedoresRow"
                                    ></tr>
                                </table>

                                <!-- Paginación -->
                                <mat-paginator
                                    #contenedoresPaginator
                                    [length]="
                                        contenedoresDataSource.data.length
                                    "
                                    [pageSize]="10"
                                    [pageSizeOptions]="[10, 25, 50, 100]"
                                    [hidePageSize]="false"
                                    showFirstLastButtons
                                ></mat-paginator>

                                <!-- Fila de totales fija al final -->
                                <div *ngIf="false" class="table-container mt-3">
                                    <table
                                        mat-table
                                        [dataSource]="[totalesContenedoresRow]"
                                        class="data-table"
                                    >
                                        <ng-container matColumnDef="nave">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                            >
                                                Nave
                                            </th>
                                            <td mat-cell *matCellDef="let r">
                                                Totales
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="pol">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                            >
                                                POL
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                            ></td>
                                        </ng-container>
                                        <ng-container matColumnDef="etd">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                            >
                                                ETD
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                            ></td>
                                        </ng-container>
                                        <ng-container matColumnDef="exportador">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                            >
                                                Exportador
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                            ></td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="nroContenedor"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                            >
                                                N° Contenedor
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                            ></td>
                                        </ng-container>
                                        <ng-container matColumnDef="refCliente">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                            >
                                                Ref. cliente
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                            ></td>
                                        </ng-container>
                                        <ng-container matColumnDef="plts">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                PLTS
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{ formatearNumero(r.plts) }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="agenciamiento"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Agenciamiento
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMoneda(
                                                        r.agenciamiento
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="transporte">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Transporte
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMoneda(
                                                        r.transporte
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="porteos">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Porteos
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'porteos'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="servicioGateOut"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Gate Out
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'servicioGateOut'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="sobrestadiaEnDeposito"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Sobrest. Dep.
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'sobrestadiaEnDeposito'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="sobrestadiaEnPlanta"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Sobrest. Plta.
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'sobrestadiaEnPlanta'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="gestionOpbNeto"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Gestión OPB
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        r.gestionOpbNeto
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="totalVentaNeto"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Venta Neto
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMoneda(
                                                        r.totalVentaNeto
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="blFee">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                BL Fee
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'blFee'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="cambioDeSellos"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Cambio Sellos
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'cambioDeSellos'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="certificadoOrigenUccoChinaEur"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Cert. Origen
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'certificadoOrigenUccoChinaEur'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="certificadoExtraOrigenUccoChinaEur"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Cert. Extra
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'certificadoExtraOrigenUccoChinaEur'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="correccionDeBl"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Corrección BL
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'correccionDeBl'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="dusLegalizado"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                DUS
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'dusLegalizado'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="securityFeeContenedor"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Security Fee
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMontoCeroVacio(
                                                        getServicioValue(
                                                            r,
                                                            'securityFeeContenedor'
                                                        )
                                                    )
                                                }}
                                            </td>
                                        </ng-container>
                                        <ng-container
                                            matColumnDef="totalTraspasoBruto"
                                        >
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef
                                                class="text-end"
                                            >
                                                Traspaso Bruto
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let r"
                                                class="text-end"
                                            >
                                                {{
                                                    formatearMoneda(
                                                        r.totalTraspasoBruto
                                                    )
                                                }}
                                            </td>
                                        </ng-container>

                                        <tr
                                            mat-header-row
                                            *matHeaderRowDef="
                                                contenedoresColumns
                                            "
                                        ></tr>
                                        <tr
                                            mat-row
                                            *matRowDef="
                                                let row;
                                                columns: contenedoresColumns
                                            "
                                            class="totales-row"
                                        ></tr>
                                    </table>
                                </div>
                            </div>

                            <div
                                *ngIf="
                                    !isLoadingContenedores &&
                                    contenedores.length === 0
                                "
                                class="no-data"
                            >
                                <mat-icon>info</mat-icon>
                                <p>
                                    No hay contenedores registrados para esta
                                    liquidación
                                </p>
                            </div>
                        </div>
                    </div>
                </mat-tab>

                <!-- Tab 3: Pallets -->
                <mat-tab label="Pallets">
                    <div class="tab-content">
                        <div class="pallets-section">
                            <h3 class="section-title">
                                Detalle de Pallets ({{
                                    palletsDataSource.data.length
                                }})
                            </h3>

                            <!-- Loading para pallets -->
                            <div
                                *ngIf="isLoadingPallets"
                                class="loading-section"
                            >
                                <mat-spinner diameter="40"></mat-spinner>
                                <p>Cargando pallets...</p>
                            </div>

                            <!-- Tabla de pallets (columnas dinámicas desde SP) -->
                            <div
                                *ngIf="!isLoadingPallets && pallets.length > 0"
                                class="table-container"
                            >
                                <table
                                    mat-table
                                    [dataSource]="palletsDataSource"
                                    class="data-table"
                                >
                                    <ng-container
                                        *ngFor="let col of palletsColumns"
                                        [matColumnDef]="col"
                                    >
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            class="nowrap-col-header"
                                        >
                                            {{ col }}
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let row"
                                            [ngClass]="{
                                                'text-end': !esColumnaTextoPallet(col),
                                                nowrap: col === 'ETD',
                                            }"
                                        >
                                            {{
                                                formatoCeldaPalletTab(
                                                    col,
                                                    row[col]
                                                )
                                            }}
                                        </td>
                                        <td
                                            mat-footer-cell
                                            *matFooterCellDef
                                            [ngClass]="{
                                                'text-end': !esColumnaTextoPallet(col),
                                            }"
                                        >
                                            {{
                                                col === palletsColumns[0]
                                                    ? 'Total'
                                                    : formatoCeldaPalletTab(
                                                          col,
                                                          totalesPalletsRow
                                                              ? totalesPalletsRow[
                                                                    col
                                                                ]
                                                              : null
                                                      )
                                            }}
                                        </td>
                                    </ng-container>
                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="palletsColumns"
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: palletsColumns
                                        "
                                    ></tr>
                                    <tr
                                        mat-footer-row
                                        *matFooterRowDef="palletsColumns"
                                        class="totales-row"
                                        [hidden]="!totalesPalletsRow"
                                    ></tr>
                                </table>

                                <!-- Paginación -->
                                <mat-paginator
                                    #palletsPaginator
                                    [length]="palletsDataSource.data.length"
                                    [pageSize]="10"
                                    [pageSizeOptions]="[10, 25, 50, 100]"
                                    [hidePageSize]="false"
                                    showFirstLastButtons
                                ></mat-paginator>
                            </div>

                            <div
                                *ngIf="
                                    !isLoadingPallets && pallets.length === 0
                                "
                                class="no-data"
                            >
                                <mat-icon>info</mat-icon>
                                <p>
                                    No hay pallets registrados para esta
                                    liquidación
                                </p>
                            </div>
                        </div>
                    </div>
                </mat-tab>

                <!-- Tab 4: Extra Servicios (SP dbo.sp_DetalleLiqAgenciaExtraServicios) -->
                <mat-tab label="Extra Servicios">
                    <div class="tab-content">
                        <div class="services-section">
                            <h3 class="section-title">
                                Detalle de servicios extra ({{
                                    extraServiciosDataSource.data.length
                                }})
                            </h3>

                            <div
                                *ngIf="isLoadingExtraServicios"
                                class="loading-section"
                            >
                                <mat-spinner diameter="40"></mat-spinner>
                                <p>Cargando servicios...</p>
                            </div>

                            <div
                                *ngIf="
                                    !isLoadingExtraServicios &&
                                    extraServicios.length > 0
                                "
                                class="table-container"
                            >
                                <table
                                    mat-table
                                    [dataSource]="extraServiciosDataSource"
                                    class="data-table"
                                >
                                    <ng-container
                                        *ngFor="
                                            let col of extraServiciosColumns
                                        "
                                        [matColumnDef]="col"
                                    >
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            class="nowrap-col-header"
                                        >
                                            {{ col }}
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let row"
                                            [ngClass]="{
                                                'text-end':
                                                    !esColumnaTextoExtraServicio(
                                                        col
                                                    ),
                                            }"
                                        >
                                            {{
                                                formatoCeldaExtraServiciosTab(
                                                    col,
                                                    row[col]
                                                )
                                            }}
                                        </td>
                                        <td
                                            mat-footer-cell
                                            *matFooterCellDef
                                            [ngClass]="{
                                                'text-end':
                                                    !esColumnaTextoExtraServicio(
                                                        col
                                                    ),
                                            }"
                                        >
                                            {{
                                                col === extraServiciosColumns[0]
                                                    ? 'Total'
                                                    : formatoCeldaExtraServiciosTab(
                                                          col,
                                                          extraServiciosTotalsRow
                                                              ? extraServiciosTotalsRow[
                                                                    col
                                                                ]
                                                              : null
                                                      )
                                            }}
                                        </td>
                                    </ng-container>
                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="extraServiciosColumns"
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: extraServiciosColumns
                                        "
                                    ></tr>
                                    <tr
                                        mat-footer-row
                                        *matFooterRowDef="extraServiciosColumns"
                                        class="totales-row"
                                        [hidden]="!extraServiciosTotalsRow"
                                    ></tr>
                                </table>

                                <mat-paginator
                                    #extraServiciosPaginator
                                    [length]="
                                        extraServiciosDataSource.data.length
                                    "
                                    [pageSize]="10"
                                    [pageSizeOptions]="[10, 25, 50, 100]"
                                    showFirstLastButtons
                                ></mat-paginator>
                            </div>

                            <div
                                *ngIf="
                                    !isLoadingExtraServicios &&
                                    extraServicios.length === 0
                                "
                                class="no-data"
                            >
                                <mat-icon>info</mat-icon>
                                <p>
                                    No hay servicios extra registrados para esta
                                    liquidación
                                </p>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-card>
</div>
